import * as React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import { FormControl, FormLabel, FormControlLabel } from '../Form';
import Radio, { RadioGroup } from '../Radio';

// Types
type IOptions = {
  value: string;
  label: string;
  disabled?: boolean;
};

// Component
export interface IProps {
  label?: string;
  fieldState: FieldState<string>;
  name?: string;
  options: IOptions[];
  row?: boolean;
  margin?: 'none' | 'normal' | 'dense';
  style?: React.CSSProperties;
}

function FormStateRadioGroup(props: IProps) {
  const { label, fieldState, options, row, margin, ...rest } = props;
  return (
    <FormControl margin={margin} fullWidth={true}>
      <FormLabel>{label}</FormLabel>
      <RadioGroup
        {...rest}
        value={fieldState.value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          fieldState.onChange(e.target.value)
        }
        onBlur={
          fieldState.dirty
            ? fieldState.enableAutoValidationAndValidate
            : undefined
        }
        row={row}
      >
        {options.map(item => (
          <FormControlLabel
            key={item.value}
            value={item.value}
            control={<Radio />}
            label={item.label}
            disabled={item.disabled}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

export default observer(FormStateRadioGroup);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FormStateFields/RadioGroup.tsx